import React, { Component } from 'react';
import { MuiButton, MuiGrid, MuiFormControlLabel, MuiTypography } from '../../../ui/MaterialUIComponents';
import lodashUtil from 'lodash';
import theme from '../../../../assests/theme'
import { CheckBox } from '../../../ui/customUIComponents'
class ElectivesListComponent extends Component {
	constructor(props) {
		super(props)
		let subjects = lodashUtil.orderBy(this.props.activeSchool.school_master.subjects, ['name'], 'asc');
		this.state = {
			subjects: subjects,
			subjectName: [],
		}
	}

	// this method compares all the subjects in the school and the subjects which are applicable for the grades picked
	compareSubjectsToEnbaleChecking = (subjectObj) => {
		let subjectsToBeEnabled = this.props.subjectsToBeEnabled;
		let flag = 'disabled';
		for (let i = 0; i < subjectsToBeEnabled.length; i++) {
			if (subjectObj.name === subjectsToBeEnabled[i].name) {
				flag = ''
				return flag;
			}
		}
		return flag;
	}

	render() {
		const { i18n } = this.props
		return (
			<MuiGrid container xs={12} direction="row" style={{ paddingLeft: "20px", top: '500px', left: '250px' }} >

				{/* mapping through the array of subject objects and taking the subjects and index of the subjects */}
				{/* and displaying all the subject names in the UI */}

				{this.props.subjectsToBeEnabled.length === 0 &&
					<MuiTypography>There are no subject to be displayed</MuiTypography>
				}
				{this.props.subjectsToBeEnabled.length !== 0 && lodashUtil.orderBy(this.props.subjectsToBeEnabled, '[name]', 'asc').map((subjectObj) => (
					<MuiGrid container xs={4} justify="flex-start" alignItems="center" id="grid">
						<MuiGrid item >
							<MuiFormControlLabel
								control={
									<CheckBox
										id="checkBox"
										disabled={this.props.compareSubjectsToEnbaleChecking(subjectObj)}
										color="primary"
										checked={subjectObj.isChecked}
										onChange={(event) => this.props.onClickOfSubject(subjectObj, "isChecked", event)}
										value={subjectObj.isChecked} />
								}
								label={subjectObj.name}

							/>
						</MuiGrid>
					</MuiGrid>
				))}

				<MuiGrid container justify="flex-end" >
					<MuiGrid item style={{ paddingRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={() => this.props.clearingOfSubjects()} >
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>
					<MuiGrid item >
						<MuiButton style={theme.primaryButtonStyle} onClick={() => this.props.savingOfElectives()}>
							{i18n.commonTexts.apply}
						</MuiButton>
					</MuiGrid>
				</MuiGrid>
			</MuiGrid>
		)
	}
}

export default ElectivesListComponent;